import React from "react";
import Heading from "../Reuse/Heading";
import IncomeCard from "../Reuse/IncomeCard";
import { BsCurrencyDollar } from "react-icons/bs";
import { BsEmojiHeartEyesFill } from "react-icons/bs";

function LearningSessionIncome({ props }) {
  return (
    <>
      <div className="row">
        <Heading
          title={"Learning Session"}
          icon={<BsEmojiHeartEyesFill size={50} />}
        />
        <IncomeCard
          title={"Total"}
          amount={props?.learningSessionTotalIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Daily"}
          amount={props?.learningSessionDailyIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Weekly"}
          amount={props?.learningSessionWeeklyIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Monthly"}
          amount={props?.learningSessionMonthlyIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Yearly"}
          amount={props?.learningSessionYearlyIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
      </div>
    </>
  );
}

export default LearningSessionIncome;
